<template>
  <div class="home">
    <div class="entrance">
      <div class="logo">
        <img src="../../static/images/logo.png"
             alt=""
             width="100%"
             height="100%" />
      </div>
      <div class="select">
        <div class="option"
             @click="openActivity()">活动预约</div>
       <!--  <div class="option"
             @click="openExhibition()">展览预约</div> -->
      </div>
    </div>
    <statistics></statistics>
  </div>
</template>
<script>
import statistics from '../components/statistics.vue'
export default {
  name: "home",
  data () {
    return {};
  },
  components: {statistics},
  methods: {
    openActivity () {
      this.$router.push(`/activity?museumCode=${this.getQueryStringRegExp("museumCode")}`);
    },
    openExhibition () {
      this.$router.push(`/exhibition?museumCode=${this.getQueryStringRegExp("museumCode")}`);
    },
    getQueryStringRegExp: function getQueryStringRegExp (name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getQueryStringRegExp("token");
      this.getQueryStringRegExp("museumCode");
      //如果获取到小程序传来的token
      if (this.getQueryStringRegExp("token")) {
        this.$store.state.token = this.getQueryStringRegExp("token");
        document.cookie = "code" + "=" + this.getQueryStringRegExp("token");
        this.isToken = false;
      } else {
        this.isToken = true;
      }
      // console.log(this.$store.state.token);
      // console.log(this.getQueryStringRegExp("museumCode"));
      //判断是否由场馆列表页转入
      if (this.getQueryStringRegExp("museumCode")) {
        this.$store.state.museumCode = this.getQueryStringRegExp("museumCode");
      }
    });
    document.body.style.backgroundColor = "#fff";
  }
};
</script>
<style lang="scss">
.entrance {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 2.653rem 0 2.76rem 0;
  background: url("../../static/images/bg.png") 0 0 / cover no-repeat;
  .logo {
    height: 372px;
    width: 433px;
    margin: 0 auto;
  }
  .select {
    width: 4.653rem;
    height: 2.747rem;
    margin: 3.04rem auto 0 auto;
    .option {
      width: 100%;
      height: 1.067rem;
      border-radius: 0.533rem;
      border: solid 0.04rem #ffffff;
      font-family: PingFangSC-Regular;
      font-size: 0.533rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 1.067rem;
      letter-spacing: 0.213rem;
      text-align: center;
      color: #ffffff;
      &:nth-child(2) {
        margin-top: 0.613rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue